export default "__VITE_ASSET__FnMpxYH___"